import { createPortal } from "react-dom";

/**
 * Universal təsdiq modalı.
 * Props:
 *   show        – boolean
 *   onHide      – fn
 *   onConfirm   – fn
 *   title       – string  (default: "Əminsiniz?")
 *   message     – string | ReactNode
 *   confirmText – string  (default: "Təsdiqlə")
 *   cancelText  – string  (default: "Ləğv et")
 *   variant     – "danger" | "warning" | "primary"  (default: "danger")
 *   loading     – boolean
 */
const VARIANT_MAP = {
  danger:  { iconClass: "bi-trash3-fill",         iconBg: "#fee2e2", iconColor: "#ef4444", btnBg: "#ef4444",  btnHover: "#dc2626" },
  warning: { iconClass: "bi-exclamation-triangle-fill", iconBg: "#fef3c7", iconColor: "#f59e0b", btnBg: "#f59e0b",  btnHover: "#d97706" },
  primary: { iconClass: "bi-check-circle-fill",   iconBg: "#dbeafe", iconColor: "#2563eb", btnBg: "#2563eb",  btnHover: "#1d4ed8" },
};

export default function ConfirmModal({
  show,
  onHide,
  onConfirm,
  title = "Əminsiniz?",
  message,
  confirmText = "Təsdiqlə",
  cancelText = "Ləğv et",
  variant = "danger",
  loading = false,
}) {
  const v = VARIANT_MAP[variant] || VARIANT_MAP.danger;

  if (!show) {
    return null;
  }

  return createPortal(
    <>
      <div
        onClick={() => {
          if (!loading) {
            onHide();
          }
        }}
        style={{
          position: "fixed",
          inset: 0,
          background: "rgba(15, 23, 42, 0.45)",
          backdropFilter: "blur(4px)",
          WebkitBackdropFilter: "blur(4px)",
          zIndex: 999999,
        }}
      />

      <div
        style={{
          position: "fixed",
          inset: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 16,
          zIndex: 1000000,
        }}
      >
        <div
          onClick={(event) => event.stopPropagation()}
          style={{
            width: "100%",
            maxWidth: 320,
            background: "#fff",
            borderRadius: 14,
            boxShadow: "0 24px 48px rgba(17, 24, 39, 0.2)",
            overflow: "hidden",
          }}
        >
          <div style={{ padding: "22px 18px 14px", textAlign: "center" }}>
            <div
              style={{
                width: 48,
                height: 48,
                background: v.iconBg,
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 12px",
              }}
            >
              <i className={`bi ${v.iconClass}`} style={{ fontSize: 20, color: v.iconColor }}></i>
            </div>

            <h6 style={{ fontWeight: 700, fontSize: 14, color: "#111827", marginBottom: 6 }}>
              {title}
            </h6>

            {message && (
              <p style={{ fontSize: 12, color: "#6b7280", lineHeight: 1.5, marginBottom: 0 }}>
                {message}
              </p>
            )}
          </div>

          <div
            style={{
              borderTop: "1px solid #f3f4f6",
              padding: "10px 18px",
              display: "flex",
              gap: 8,
              justifyContent: "center",
            }}
          >
            <button
              onClick={onHide}
              disabled={loading}
              style={{
                flex: 1,
                padding: "8px 0",
                background: "#fff",
                color: "#374151",
                border: "1px solid #e5e7eb",
                borderRadius: 8,
                fontWeight: 600,
                fontSize: 12,
                cursor: loading ? "not-allowed" : "pointer",
                transition: "all 0.15s",
              }}
            >
              {cancelText}
            </button>
            <button
              onClick={onConfirm}
              disabled={loading}
              style={{
                flex: 1,
                padding: "8px 0",
                background: v.btnBg,
                color: "#fff",
                border: "none",
                borderRadius: 8,
                fontWeight: 600,
                fontSize: 12,
                cursor: loading ? "not-allowed" : "pointer",
                opacity: loading ? 0.7 : 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 6,
                transition: "all 0.15s",
              }}
            >
              {loading && <i className="bi bi-arrow-clockwise" style={{ animation: "spin 0.8s linear infinite" }}></i>}
              {confirmText}
            </button>
          </div>
        </div>
      </div>

      <style>{`@keyframes spin { from{transform:rotate(0deg)} to{transform:rotate(360deg)} }`}</style>
    </>,
    document.body
  );
}
